import { render, staticRenderFns } from "./Cocinas.vue?vue&type=template&id=e9e84734"
import script from "./Cocinas.vue?vue&type=script&lang=js"
export * from "./Cocinas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports